import React__default from 'react';
import { useProductOptionsTranslations } from '../../product-options-translations/product-option-translations.mjs';
import { PricePerUnit, RawPrice } from '@vp/vp-tokenized-fragment';
import { SecondaryPlusOrMinusFullPrices } from './components/secondary-plus-or-minus-full-prices.mjs';
import { SecondaryPlusOrMinusPerUnitPrices } from './components/secondary-plus-or-minus-per-unit-prices.mjs';

function hasPrices(differentialUnitListPrice, differentialUnitDiscountPrice) {
    return !!differentialUnitListPrice || !!differentialUnitDiscountPrice;
}
const OptionPriceDisplay = ({ choice, priceDisplayMode, locale, currency, fractionDigits, hideZeroPrice = true, vatInc = false, hideVatMessage = true, tenant, }) => {
    const { i18n } = useProductOptionsTranslations();
    return (React__default.createElement(React__default.Fragment, null, priceDisplayMode !== "none" && (React__default.createElement(React__default.Fragment, null,
        priceDisplayMode === "differential-total" && (React__default.createElement(SecondaryPlusOrMinusFullPrices, { choice: choice, pricePlaceholder: i18n("pricePlaceholder"), locale: locale, currency: currency, fractionDigits: fractionDigits, vatInc: vatInc, hideVatMessage: hideVatMessage })),
        priceDisplayMode === "differential-unit" &&
            hasPrices(choice.differentialUnitListPrice, choice.differentialUnitDiscountPrice) && (React__default.createElement(SecondaryPlusOrMinusPerUnitPrices, { choice: choice, pricePlaceholder: i18n("pricePlaceholder"), locale: locale, currency: currency, fractionDigits: fractionDigits, hideZeroPrice: hideZeroPrice })),
        priceDisplayMode === "unit" &&
            hasPrices(choice.unitDiscountedPrice, choice.unitListPrice) && (React__default.createElement(PricePerUnit, { tenant: tenant, placeHolderText: i18n("pricePlaceholder"), pricingInfo: {
                currency,
                minimumFractionDigits: fractionDigits,
                culture: locale,
                unitDiscountPrice: choice.unitDiscountedPrice ?? 0,
                unitListPrice: choice.unitListPrice ?? 0,
                vatInc,
                hideVatMessage,
            } })),
        priceDisplayMode === "total" &&
            hasPrices(choice.totalDiscountedPrice, choice.totalListPrice) && (React__default.createElement(RawPrice, { tenant: tenant, placeHolderText: i18n("pricePlaceholder"), pricingInfo: {
                currency,
                minimumFractionDigits: fractionDigits,
                culture: locale,
                discountPrice: choice.totalDiscountedPrice ?? 0,
                listPrice: choice.totalListPrice ?? 0,
                vatInc,
                hideVatMessage,
            } }))))));
};

export { OptionPriceDisplay };
//# sourceMappingURL=option-price-display.mjs.map
